import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "stepper" }
const _hoisted_2 = { class: "circle" }
const _hoisted_3 = { class: "label" }
const _hoisted_4 = {
  key: 0,
  class: "divider"
}


export default /*@__PURE__*/_defineComponent({
  __name: 'StepBar',
  props: {
    modelValue: {},
    items: {}
  },
  setup(__props: any) {

// eslint-disable-next-line no-undef


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.items, (item, index) => {
      return (_openBlock(), _createElementBlock("div", {
        key: index,
        class: _normalizeClass(["step", {
        active: _ctx.modelValue === index,
        done: index < _ctx.modelValue
      }])
      }, [
        _createElementVNode("div", _hoisted_2, _toDisplayString(index + 1), 1),
        _createElementVNode("div", _hoisted_3, _toDisplayString(item), 1),
        (index !== _ctx.items.length - 1)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4))
          : _createCommentVNode("", true)
      ], 2))
    }), 128))
  ]))
}
}

})